<template>
  <div class="photo-club">
    <div class="foto_-container">
      <img class="foto_jugador" :src="foto_Jugador" alt="foto_jugador" /><img
        class="foto_club"
        :src="foto_Equipo"
        alt="foto_club"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoClub',
  props: ['foto_Jugador', 'foto_Equipo'],
};
</script>

<style>
.photo-club,
.photo-club-1,
.photo-club-2 {
  height: 43.66px;
  min-width: 41.6px;
  position: relative;
}

.foto_-container,
.foto_-container-1,
.foto_-container-2 {
  height: 44px;
  left: -2px;
  position: relative;
  width: 44px;
}

.foto_jugador,
.foto_jugador-1,
.foto_jugador-2 {
  height: 46px;
  left: 16px;
  object-fit: cover;
  position: absolute;
  top: 3px;
  width: 33px;
  border-radius: 6.1px;
  border: solid 2px #7ed321;
}

.foto_club,
.foto_club-1,
.foto_club-2 {
  height: 23px;
  left: 4px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 23px;
}
</style>
